import { configureStore } from '@reduxjs/toolkit';
import { itinerarySlice } from 'pages/itinerary/ItinerarySlice';
import { mapSlice } from 'pages/itinerary/MapSlice';
import { itineraryComparisonSlice } from 'pages/itineraryComparison/ItineraryComparisonSlice';
import { capacityPlanningSlice } from 'core/store/CapacityPlanningSlice';

const reducer = {
  itineraryReducer: itinerarySlice.reducer,
  mapReducer: mapSlice.reducer,
  itineraryComparisonReducer: itineraryComparisonSlice.reducer,
  capacityPlanningReducer: capacityPlanningSlice.reducer,
};

/**
 * A store of its own. The app uses the singleton below; a test builds one per
 * render so nothing it dispatches leaks into the next test.
 */
export const makeStore = () => configureStore({ reducer });

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
